if(!customElements.get('featured-products')) {
  class ComponentFeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.collectionFilter = this.querySelector('.collection-filter');
      this.selectedCollection = (this.collectionFilter) ? this.collectionFilter.querySelector('input[type="radio"]:checked') : null;
      this.collectionDescription = this.querySelector('.collection-description');
      this.btnsShop = this.querySelectorAll('.btn-shop');
      this.slides = this.querySelectorAll('.keen-slider-slide');

      this.sliderElement = this.querySelector('.keen-slider');
      this.sliderNav = this.parentNode.querySelector('.keen-nav');
      if (this.sliderNav) {
        this.sliderNavCurrent = this.sliderNav.querySelector('.current');
        this.sliderNavTotal = this.sliderNav.querySelector('.total');
      }
      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);

      if (this.collectionFilter) {
        this.collectionFilter.querySelectorAll('input[type="radio"]').forEach( radio => radio.addEventListener('change', this.onChangeCollectionFilter.bind(this)));
      }
    }

    initSlider() {
      this.filterSlides();
      var config = {
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        prevButton: this.querySelector('.keen-arrow.prev'),
        nextButton: this.querySelector('.keen-arrow.next'),
        autoplay: this.carouselAutoplay,
        slideChanged: (keen,i)=>{
          if (this.sliderNavCurrent && this.sliderNavTotal) {
            this.sliderNavCurrent.innerHTML = keen.details().absoluteSlide+1;
            this.sliderNavTotal.innerHTML = Math.ceil(keen.details().size - Math.round(keen.details().slidesPerView-1));
          }
        },
        breakpoints: {
          '(min-width: 901px)': {
            centered: this.carouselCenteredDesktop=="true",
            spacing: this.carouselSpacingDesktop,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 900px)': {
            centered: this.carouselCenteredTablet=="true",
            spacing: this.carouselSpacingTablet,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: this.carouselCenteredMobile=="true",
            spacing: this.carouselSpacingMobile,
            slidesPerView: this.slidesPerViewMobile
          }
        }
      }
      var dots = this.querySelector('.keen-dots');
      if (dots) {
        config = {...config, dots: dots};
      } else {
        var band = this.querySelector('.keen-nav-bar');
        config = {...config, navBar: band, rubberband: false};
      }
      this.sliderObj = new KeenSlider(this.sliderElement, config);
    }

    filterSlides() {
      if (this.collectionFilter) {
        this.slides.forEach((slide)=> {
          slide.style.display = slide.dataset.collection==this.selectedCollection.value ? '' : 'none';
        });
        this.btnsShop.forEach( btn => btn.setAttribute('href', '/collections/'+this.selectedCollection.value));
        this.collectionDescription.innerHTML = this.selectedCollection.dataset.collectionDescription;
      }
    }

    onChangeCollectionFilter() {
      this.selectedCollection = this.collectionFilter.querySelector('input[type="radio"]:checked');
      this.filterSlides();
      this.sliderObj.refresh();
    }
  }
  customElements.define('featured-products', ComponentFeaturedProducts);
}